
































































import { Vue, Component } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import {
    RESET_EDITOR,
    ENTRY_UPDATE,
    EDITOR_SET_FIELD_DATA,
    ENTRY_INSERT
} from '@/store/editor/constants'
import IconSelector from './IconSelector.vue'
import VaultSelector from './VaultSelector.vue'
import DeleteModal from '../DeleteModal.vue'

@Component({ name: 'editor-header', components: { IconSelector, VaultSelector, DeleteModal } })
export default class EditorHeader extends Vue {
    /**
     * Whether to show the delete confirmation modal
     */
    deleteModalOpen: boolean = false

    /**
     * Clear the editor
     */
    @Action(RESET_EDITOR)
    clear!: () => void

    /**
     * Commit the change to the entry
     */
    @Action(ENTRY_UPDATE)
    updateEntry!: () => Promise<void>

    /**
     * Save the new entry that is loaded in the editor
     */
    @Action(ENTRY_INSERT)
    create!: () => void

    /**
     * Set the value for a field
     */
    @Mutation(EDITOR_SET_FIELD_DATA)
    setFieldData!: ({ key, value }: { key: string, value: string }) => void

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    get existing(): boolean {
        return this.entry.existing
    }

    get title(): string {
        return this.entry.fields.title.value || ''
    }

    get error(): string {
        return this.entry.fields.title.error || ''
    }

    toggleDeleteModal(): void {
        this.deleteModalOpen = !this.deleteModalOpen
    }

    updateTitle(value: string): void {
        const old = this.title
        this.setFieldData({ key: 'title', value })
        if (this.existing) {
            this.updateEntry()
        }
    }
}
